import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { bindLinesForm } from '../common';
import { handleCustomerSelector } from 'modules/saas/pco/cases/demand';
import App from './App';
import { applyPaymentDelay } from 'modules/saas/invoices/lines';
import moment from 'moment';
import { withCurrentReferer } from 'plugins/contextual-back';

const setPaymentDate = (issueDate, modificationAllowed) => {
  const $paymentDateInput = $('#invoice_date');

  if (issueDate) {
    $paymentDateInput.val(issueDate.format('DD/MM/YYYY'));
  } else {
    $paymentDateInput.val('');
  }

  if (modificationAllowed) {
    $paymentDateInput
      .removeClass('disabled')
      .removeClass('ui')
      .removeClass('field');
  } else {
    $paymentDateInput
      .addClass('disabled')
      .addClass('ui')
      .addClass('field');
  }
};

const handlePaymentDate = () => {
  const $input = $('#invoice_paymentDelay');

  if ($input && $input.length) {
    applyPaymentDelay($input.val(), moment(), false, setPaymentDate);

    $input.on('change', evt => {
      evt.preventDefault();
      applyPaymentDelay($(evt.target).val(), moment(), true, setPaymentDate);
    });
  }
};

export const create = () => {
  handleCustomerSelector(bindFastDemandForm);
  handlePaymentDate();
};

function bindFastDemandForm($form, customer) {
  const $submit = $form.find('button[type="submit"]');

  const enableButton = () => $submit.removeClass('disabled');
  const disableButton = () => $submit.addClass('disabled');

  // Make submit button disabled while not site selected
  disableButton();

  // Display site selector
  ReactDOM.render(
    <App
      customer={customer}
      onSiteSelected={enableButton}
      onSiteUnselected={disableButton}
    />,
    document.getElementById('root')
  );

  // Display form
  $('#demand-form').show();

  bindLinesForm($form);
}



// WEBPACK FOOTER //
// ./src/modules/saas/demands/fast/index.js